/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Statement_Taxonomy_Editor_ReorderInputs */

const en_statement_taxonomy_editor_reorder = /** @type {(inputs: Statement_Taxonomy_Editor_ReorderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reorder ${i?.label}`)
};

const nl_statement_taxonomy_editor_reorder = /** @type {(inputs: Statement_Taxonomy_Editor_ReorderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} verplaatsen`)
};

/**
* | output |
* | --- |
* | "Reorder {label}" |
*
* @param {Statement_Taxonomy_Editor_ReorderInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_reorder = /** @type {((inputs: Statement_Taxonomy_Editor_ReorderInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_ReorderInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_reorder(inputs)
	return en_statement_taxonomy_editor_reorder(inputs)
});